import * as React from "react";
import {Fragment} from "react";
import PaymentArrivedNotification from "../../../model/notification/payment/PaymentArrivedNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: PaymentArrivedNotification;
}

/**
 * Payment arrived notification toast body.
 */
const NotificationPaymentArrivedBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Payment {props.notification.data.jobRefNumber.orNull}</div>
			<div className={"toast-body"}>
				Payment has arrived
			</div>
		</Fragment>
	);
};

export default NotificationPaymentArrivedBody;
